module.exports = __webpack_public_path__ + "static/Christine-Michael-Irwin-800x500-3bb42176d7ae0c341abfa84eb6a081f6.jpg";